import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
  Paper,
  Box,
  InputLabel,
  Select,
  FormControl,
  Card,
  Avatar,
  IconButton,
  FormHelperText,
  CircularProgress,
  Tooltip,
  Snackbar,
  Alert,
  Chip,
} from "@mui/material";
import { FirstPage, ChevronLeft, ChevronRight, LastPage, Edit } from "@mui/icons-material";
import { MaterialReactTable } from "material-react-table";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { useQuery } from "@tanstack/react-query";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import handleExport from "utils/exportData";
import { IconTableExport } from "@tabler/icons-react";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import MDBox from "components/MDBox";
import MDAutocomplete from "components/MDAutocomplete";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDTextField from "components/MDTextField";
import { convertUtcToIST } from "utils/ISTConvert";
import MDProgress from "components/MDProgress";
import PropTypes from "prop-types";

const AggregatedCellRenderer = ({ cell, table }) => (
  <>
    Rs.
    <Box sx={{ display: "inline", fontWeight: "bold" }}>
      {cell.row.leafRows.reduce((sum, item) => sum + item.original[cell.column.id], 0)}
    </Box>
  </>
);

AggregatedCellRenderer.propTypes = {
  cell: PropTypes.object.isRequired,
  table: PropTypes.object.isRequired,
};

const options = [
  { title: "100% - Fully Functioning", value: 100, color: "color_100" },
  { title: "75% - Connected", value: 75, color: "color_75" },
  { title: "50% - Installed", value: 50, color: "color_50" },
  { title: "25% - Supplies Procured", value: 25, color: "color_25" },
  { title: "0% - Not yet Started", value: 0, color: "color_0" },
];

const options1 = [
  { title: "100% - Gardening", value: 100, color: "color_100" },
  { title: "75% - Levelling", value: 75, color: "color_75" },
  { title: "25% - location identified", value: 25, color: "color_25" },
  { title: "0% - Not yet Started", value: 0, color: "color_0" },
];
const options2 = [
  { title: "100% - Appointed", value: 100, color: "color_100" },
  { title: "50% - Selected", value: 50, color: "color_50" },
  { title: "25% - Supplies Procured", value: 25, color: "color_25" },
  { title: "0% - Not yet Started", value: 0, color: "color_0" },
];
const options3 = [
  { title: "100% - Fully Functioning", value: 100, color: "color_100" },
  { title: "75% - Connection to drip irrigation", value: 75, color: "color_75" },
  { title: "50% - Connection to sump", value: 50, color: "color_50" },
  { title: "25% - Location identified", value: 25, color: "color_25" },
  { title: "0% - Not yet Started", value: 0, color: "color_0" },
  { title: "NA", value: 100, color: "color_NA" },
  { title: "Digging", value: 100, color: "color_Digging" },
  { title: "Bore well completed", value: 100, color: "color_Bore" },
  { title: "Not needed", value: 100, color: "color_notneeded" },
];
const options4 = [
  { title: "100% - Fully Functioning", value: 100, color: "color_100" },
  { title: "75% - Connected to Sump", value: 75, color: "color_75" },
  { title: "50% - Roof top connection", value: 50, color: "color_50" },
  { title: "25% - Supplies Procured", value: 25, color: "color_25" },
  { title: "0% - Not yet Started", value: 0, color: "color_0" },
  { title: "NA", value: 100, color: "color_NA" },
];
const options5 = [
  { title: "100% - Fully Functioning", value: 100, color: "color_100" },
  { title: "75% - Digging completed", value: 75, color: "color_75" },
  { title: "50% - Marking", value: 50, color: "color_50" },
  { title: "25% - Selection of location", value: 25, color: "color_25" },
  { title: "0% - Not yet Started", value: 0, color: "color_0" },
];

const GreenSchoolList = () => {
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [columnFilters, setColumnFilters] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filters, setFilters] = useState({
    txtGroup: "",
    intDistrict: "",
    txtSchoolName: "",
    intPhase: "",
    // txtDistrict: "",
    // txtGender: "",
    // intStatus: "",
    // txtDateofJoin: null,
  });
  const genders = [
    { title: "Male", value: "Male" },
    { title: "Female", value: "Female" },
    { title: "Other", value: "Other" },
  ];
  const [sorting, setSorting] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [exportData, setExportData] = useState([]);
  const [message, setMessage] = useState({
    status: "",
    title: "",
    msg: "",
  });
  const navigate = useNavigate();

  // useEffect

  const me = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    // console.log("🚀 ~ fetchUsers ~ response:", response);
    return response.data;
  };

  const {
    data: meData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["me"], // Unique key for the query
    queryFn: me, // The async function to run
    retry: false,
  });

  const fetchGroups = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/green-school/groups`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: fetchedGroups,
    error: roleError,
    isLoading: roleIsLoading,
  } = useQuery({
    queryKey: ["fetchGroups"],
    queryFn: fetchGroups,
    retry: false,
  });

  /* const fetchActivePhases = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/green-school-phases/active`,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
    return response.data.data || [];
  };

  const { data: activePhases = [] } = useQuery({
    queryKey: ["activePhases"],
    queryFn: fetchActivePhases,
    retry: false,
  }); */

  const fetchUserData = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: fetchedUserData,
    error: userError,
    isLoading: userIsLoading,
  } = useQuery({
    queryKey: ["fetchUserData"],
    queryFn: fetchUserData,
    retry: false,
  });

  const fetchUsers = async (
    pageIndex = 0,
    pageSize = 10,
    filterValues = filters,
    sortValues = sorting,
    columnFilters = [],
    meDatanew,
    district = 0
  ) => {
    setLoading(true);
    try {
      /* const selectedPhase = activePhases.find(p => p.value === filterValues.intPhase);
      const phaseName = selectedPhase ? selectedPhase.title : (filterValues.intPhase || ""); */
      const phaseName = filterValues.intPhase || "";

      const queryParams = new URLSearchParams({
        page: pageIndex + 1,
        limit: pageSize,
        columnFilters: JSON.stringify(columnFilters),
        txtGroup: filterValues.txtGroup,
        intDistrict:
          meData?.role_id === 3
            ? meData.district
            : district === 0
              ? filterValues.intDistrict
              : district,
        txtSchoolName: filterValues.txtSchoolName,
        intPhase: phaseName,
        // intPhone: filterValues.intPhone,
        // txtGender: filterValues.txtGender,
        // intStatus: filterValues.intStatus,
        // txtDateofJoin: filterValues.txtDateofJoin
        //   ? dayjs(filterValues.txtDateofJoin).format("DD-MM-YYYY")
        //   : "",
      });

      // Append sorting info
      if (sortValues.length > 0) {
        const sortField = sortValues[0].id;
        const sortOrder = sortValues[0].desc ? "desc" : "asc";
        queryParams.append("sortField", sortField);
        queryParams.append("sortOrder", sortOrder);
      }

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/green-school/all?${queryParams.toString()}`,
        {
          withCredentials: true,
        }
      );

      if (res.data.status === 200) {
        setData(res.data.data);
        setRowCount(res.data.total ?? 0);
        setExportData(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching users:", err);
    }
    setLoading(false);
  };

  const handleFirstPage = () => {
    if (pagination.page > 0) fetchUsers(0);
  };

  const handlePrevPage = () => {
    if (pagination.page > 0) fetchUsers(pagination.page - 1);
  };

  const handleNextPage = () => {
    if (pagination.page < pagination.totalPages - 1) fetchUsers(pagination.page + 1);
  };

  const handleLastPage = () => {
    if (pagination.page < pagination.totalPages - 1) fetchUsers(pagination.totalPages - 1);
  };

  const fetchDistrict = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/districts/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  let {
    data: districtData,
    error: districtError,
    isLoading: districtIsLoading,
  } = useQuery({
    queryKey: ["fetchDistrict"],
    queryFn: fetchDistrict,
    retry: false,
  });
  const [districts, setDistricts] = useState([]);
  useEffect(() => {
    //  useEffect(() => {
    if (meData?.role_id === 3) {
      // formik.setFieldValue("intDistrict", meData?.district);
      if (districtData?.length > 0) {
        districtData = districtData.filter((obj) => obj.value === meData?.district);
      }
      setFilters({ ...filters, intDistrict: meData?.district });
      fetchUsers(
        pagination.pageIndex,
        pagination.pageSize,
        filters,
        sorting,
        columnFilters,
        meData,
        meData?.district
      );
    } else {
      setDistricts(districtData);
      fetchUsers(
        pagination.pageIndex,
        pagination.pageSize,
        filters,
        sorting,
        columnFilters,
        meData
      );
    }
    // console.log("🚀 ~ GreenSchoolList ~ filters:", filters);
    // }, [meData]);
  }, [pagination, sorting, columnFilters, meData, districtData]);

  const fetchStatus = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/status/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: fetchedStatus,
    error: statusError,
    isLoading: statusIsLoading,
  } = useQuery({
    queryKey: ["fetchStatus"],
    queryFn: fetchStatus,
    retry: false,
  });

  const statusData =
    fetchedStatus?.map((status) => ({
      title: status.name,
      value: status.status_id,
    })) || [];

  const columns = useMemo(
    () => [
      // const columns = [
      {
        accessorKey: "group_name",
        header: "Group",
        // size: 150,
      },

      {
        accessorKey: "district_name",
        header: "District",
        Cell: ({ row }) => (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="h6"> {row.original.district_name ?? "-"} </MDTypography>
            <MDTypography variant="caption"> {row.original.created_user ?? "-"}</MDTypography>
          </MDBox>
        ),
        // size: 120,
      },
      {
        accessorKey: "school_name",
        header: "School Name",
        Cell: ({ row }) => (
          <Tooltip title={row.original.school_name ?? "-"}>
            <span>{row.original.school_name ?? "-"}</span>
          </Tooltip>
        ),
        size: 300,
      },
      {
        accessorKey: "agri1",
        header: "Solar Panel, Tubular battery/ Ongrid, lightings",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const temp = options.find((option) => option.title === row.original.agriculture_1);
          return (
            <MDBox width="10rem" textAlign="left">
              <MDProgress
                value={temp?.value || 0}
                color={temp?.color || "primary"}
                label={true}
                title={temp?.title || ""}
              />
              {row.original.agriculture_1_agency && (
                <MDTypography
                  variant="caption"
                  color="text"
                  sx={{ display: "block", mt: 0.5, fontWeight: "bold" }}
                >
                  Agency: {row.original.agriculture_1_agency}
                </MDTypography>
              )}
            </MDBox>
          );
        },
      },
      {
        accessorKey: "agri2",
        header: "Bore well, Drip Irrigation",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const temp = options3.find((option) => option.title === row.original.agriculture_2);
          return (
            <MDBox width="10rem" textAlign="left">
              <MDProgress
                value={temp?.value || 0}
                color={temp?.color || "primary"}
                label={true}
                title={temp?.title || ""}
              />
              {row.original.agriculture_2_agency && (
                <MDTypography
                  variant="caption"
                  color="text"
                  sx={{ display: "block", mt: 0.5, fontWeight: "bold" }}
                >
                  Agency: {row.original.agriculture_2_agency}
                </MDTypography>
              )}
            </MDBox>
          );
        },
      },
      {
        accessorKey: "agri3",
        header: "Rain water Harvest",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const temp = options4.find((option) => option.title === row.original.agriculture_3);
          return (
            <MDBox width="10rem" textAlign="left">
              <MDProgress
                value={temp?.value || 0}
                color={temp?.color || "primary"}
                label={true}
                title={temp?.title || ""}
              />
              {row.original.agriculture_3_agency && (
                <MDTypography
                  variant="caption"
                  color="text"
                  sx={{ display: "block", mt: 0.5, fontWeight: "bold" }}
                >
                  Agency: {row.original.agriculture_3_agency}
                </MDTypography>
              )}
            </MDBox>
          );
        },
      },
      {
        accessorKey: "hori1",
        header: "Compost",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const temp = options5.find((option) => option.title === row.original.horticulture_1);
          return (
            <MDBox width="10rem" textAlign="left">
              <MDProgress
                value={temp?.value || 0}
                color={temp?.color || "primary"}
                label={true}
                title={temp?.title || ""}
              />
              {row.original.horticulture_1_agency && (
                <MDTypography
                  variant="caption"
                  color="text"
                  sx={{ display: "block", mt: 0.5, fontWeight: "bold" }}
                >
                  Agency: {row.original.horticulture_1_agency}
                </MDTypography>
              )}
            </MDBox>
          );
        },
      },
      {
        accessorKey: "hori2",
        header: "Vegetable Garden, Medicinal garden, Planting of fruit bearing trees",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const temp = options1.find((option) => option.title === row.original.horticulture_2);
          return (
            <MDBox width="10rem" textAlign="left">
              <MDProgress
                value={temp?.value || 0}
                color={temp?.color || "primary"}
                label={true}
                title={temp?.title || ""}
              />
              {row.original.horticulture_2_agency && (
                <MDTypography
                  variant="caption"
                  color="text"
                  sx={{ display: "block", mt: 0.5, fontWeight: "bold" }}
                >
                  Agency: {row.original.horticulture_2_agency}
                </MDTypography>
              )}
            </MDBox>
          );
        },
      },
      {
        accessorKey: "garden",
        header: "Garden Maintenance",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const temp = options2.find((option) => option.title === row.original.hiring);
          return (
            <MDBox width="8rem" textAlign="left" background="red">
              <MDProgress
                value={temp?.value || 0}
                color={temp?.color || "primary"}
                label={true}
                title={temp?.title || ""}
              />
            </MDBox>
          );
        },
      },
      {
        accessorKey: "hiring_completed",
        header: "Completed (Nos.)",
        Cell: ({ row }) => row.original.hiring_completed ?? "0",
      },
      {
        accessorKey: "amount_received",
        header: "Amount Received",
        Cell: ({ row }) => row.original.amount_received ?? "0",
      },
      {
        accessorKey: "expenditure_incurred",
        header: "Expenditure incurred",
        Cell: ({ row }) => row.original.expenditure_incurred ?? "0",
      },
      {
        accessorKey: "expenditure_to_be_incurred",
        header: "Expenditure to be incurred",
        Cell: ({ row }) => row.original.expenditure_to_be_incurred ?? "0",
      },
      {
        accessorKey: "balance_available",
        header: "Balance available",
        Cell: ({ row }) => row.original.balance_available ?? "0",
      },
      {
        accessorKey: "uc_status",
        header: "UC Status",
        Cell: ({ row }) => row.original.uc_status ?? "-",
      },
      // {
      //   accessorKey: "completed",
      //   header: "Completed (Nos.)",
      //   // Cell: ({ row }) => {
      //   //   const temp = options.find((option) => option.title === row.original.hiring);
      //   //   return (
      //   //     <MDBox width="8rem" textAlign="left" background="red">
      //   //       <MDProgress value={temp.value} color={temp.color} label={true} title={temp.title} />
      //   //     </MDBox>
      //   //   );
      //   // },
      // },
      {
        accessorKey: "date_of_inspection",
        header: "Tentative date of Inspection",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const date = row.original.date_of_inspection;
          return date && date !== "null" ? (convertUtcToIST(date) ?? "-") : "-";
        },
      },

      {
        accessorKey: "Remarks",
        header: "Remarks",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          return (
            <Tooltip title={row.original.remarks ?? "-"}>
              <span
                style={{
                  display: "block",
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {row.original.remarks ?? "-"}
              </span>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "committed_expenditure",
        header: "Total Committed Expenditure(paid or yet to pay)in Rs.",
        Cell: ({ row }) => {
          return row.original.committed_expenditure ?? "0";
        },
        AggregatedCell: AggregatedCellRenderer,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "unused_amount",
        header: "Total Unused Amount(expected or present)in Rs.",
        Cell: ({ row }) => {
          return row.original.unused_amount ?? "0";
        },
        AggregatedCell: AggregatedCellRenderer,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "edit",
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Box display="flex" alignItems="center" gap={1}>
            <Tooltip title="Click to edit">
              <span>
                <IconButton
                  key={row.id}
                  onClick={() => {
                    navigate(`/green-school/add/${row.original.id}`);
                  }}
                  disabled={loading}
                  sx={{
                    color: "#f48c06",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                    transition: "background-color 0.3s, transform 0.3s",
                    "&:hover": {
                      backgroundColor: "#f48c06",
                      color: "#fff",
                      transform: "scale(1.05)",
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <Edit sx={{ width: 20, height: 20 }} />
                  )}
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        ),
      },
      {
        accessorKey: "created_user",
        header: "Submitted By",
        Cell: ({ row }) => row.original.created_user ?? "-",
      },
      {
        accessorKey: "created_at",
        header: "Submitted At",
        Cell: ({ row }) =>
          row.original.created_at ? convertUtcToIST(row.original.created_at) : "-",
      },
      // {
      //   accessorKey: "gender",
      //   header: "Gender",
      //   Cell: ({ row }) => row.original.gender ?? "-",
      //   // size: 100,
      // },
      // {
      //   accessorKey: "status",
      //   header: "Status",
      //   Cell: ({ row }) => {
      //     const statusId = row.original.status;
      //     const status = statusData?.find((s) => s.value === statusId);
      //     return (
      //       <Chip
      //         label={status?.title ?? "-"}
      //         sx={{
      //           height: "auto",
      //           "& .MuiChip-label": {
      //             color: "white !important",
      //             fontSize: "14px",
      //             fontWeight: "bold",
      //           },
      //         }}
      //         color={
      //           status?.title === "Active"
      //             ? "success"
      //             : status?.title === "Inactive"
      //             ? "error"
      //             : "warning"
      //         }
      //       />
      //     );
      //   },
      //   // size: 120,
      // },
      // {
      //   accessorKey: "date_of_join",
      //   header: "Date of Join",
      //   Cell: ({ row }) => {
      //     // return convertUtcToIST(row.original.date_of_join) ?? "-";
      //     return (
      //       <MDBox width="8rem" textAlign="left" background="red">
      //         <MDProgress value={10} color="primary" variant="gradient" label={true} />
      //       </MDBox>
      //     );
      //   },
      //   // row.original.date_of_join ? moment(row.original.date_of_join).format("YYYY-MM-DD") : "-",
      //   // size: 130,
      // },

      // {
      //   accessorKey: "edit",
      //   header: "Action",
      //   enableColumnFilter: false,
      //   // size: 100,
      //   Cell: ({ row }) => {
      //     return (
      //       // Only show Edit button if row is selected
      //       <Box display="flex" alignItems="center" gap={1}>
      //         <Tooltip title={"Click to edit"}>
      //           <span>
      //             {" "}
      //             {/* Needed to wrap disabled buttons with tooltips */}
      //             <IconButton
      //               key={row.user_id}
      //               onClick={() => {
      //                 navigate(`/user/user-add/${row.original.user_id}`);
      //               }}
      //               disabled={loading}
      //               sx={{
      //                 color: "#f48c06",
      //                 backgroundColor: "#fff",
      //                 boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
      //                 transition: "background-color 0.3s, transform 0.3s",
      //                 "&:hover": {
      //                   backgroundColor: "#f48c06",
      //                   color: "#fff",
      //                   transform: "scale(1.05)",
      //                 },
      //                 "&:active": {
      //                   transform: "scale(0.95)",
      //                 },
      //               }}
      //             >
      //               {loading ? (
      //                 <CircularProgress size={20} color="inherit" />
      //               ) : (
      //                 <Edit sx={{ width: 20, height: 20 }} />
      //               )}
      //             </IconButton>
      //           </span>
      //         </Tooltip>
      //       </Box>
      //     ); // Hide button if not selected
      //   },
      //   // muiTableHeadCellProps: {
      //   //   sx: {
      //   //     color: "#fff",
      //   //     backgroundColor: "primary.main", // Match your table header background
      //   //     zIndex: 3,
      //   //   },
      //   // },

      //   enableSorting: false,
      // },

      // return columns;
    ],
    [options, options1, options2, meData]
  );

  const filteredColumns = useMemo(() => {
    let cols = columns;
    if (meData?.role_id === 3) {
      // For Fellows, hide submission columns
      cols = cols.filter(
        (col) => col.accessorKey !== "created_user" && col.accessorKey !== "created_at"
      );
    } else {
      // For Admins (non-Fellows), hide Action/Edit columns
      cols = cols.filter((col) => col.accessorKey !== "edit" && col.accessorKey !== "action");
    }
    return cols;
  }, [columns, meData]);

  // useEffect(() => {
  //   if (meData?.role_id === 3) {
  //     formik.setFieldValue("intDistrict", meData?.district);
  //     districtData = districtData.filter((obj) => obj.value === meData?.district);
  //   }
  //   setDistricts(districtData);
  // }, [meData]);

  const handleExportData = async () => {
    try {
      let formattedData = [];

      if (rowSelection && Object.keys(rowSelection).length > 0) {
        formattedData = exportData.filter((item) => rowSelection[item.id]);
      } else {
        const queryParams = new URLSearchParams({
          txtGroup: filters.txtGroup,
          intDistrict: filters.intDistrict,
          txtSchoolName: filters.txtSchoolName,
          // intPhone: filters.intPhone,
          // txtGender: filters.txtGender,
          // intStatus: filters.intStatus,
          // txtDateofJoin: filters.txtDateofJoin
          //   ? dayjs(filters.txtDateofJoin).format("DD-MM-YYYY")
          //   : "",
          page: 1,
          limit: 10000,
        });

        if (sorting.length > 0) {
          const sortField = sorting[0].id;
          const sortOrder = sorting[0].desc ? "desc" : "asc";
          queryParams.append("sortField", sortField);
          queryParams.append("sortOrder", sortOrder);
        }

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/green-school/all?${queryParams.toString()}`,
          {
            withCredentials: true,
          }
        );

        if (res.data.status === 200) {
          formattedData = res.data.data;
        }
      }

      if (formattedData.length === 0) {
        // console.log("No data found to export");
        setMessage({
          status: "error",
          title: "Error",
          msg: "No data found to export.",
        });
        return;
      }

      await handleExport(formattedData, "Green_School_List_Data", fetchedUserData?.data || []);

      setMessage({
        status: "success",
        title: "Success",
        msg: "Excel downloaded successfully!",
      });
    } catch (error) {
      console.error(" Export error:", error);
      setMessage({
        status: "error",
        title: "Error",
        msg: "Something went wrong during export.",
      });
    }
  };

  return (
    <DashboardLayout>
      {/* <Card id="delete-account">
        <MDBox mb={2} />
      </Card> */}
      <MDBox mt={3} />
      <Card id="delete-account" sx={{ mb: 2 }}>
        <MDBox pt={2} px={2} pb={3}>
          {/* <MDBox mt={5} mb={3}> */}
          <Grid container spacing={1} display={"flex"} alignItems={"center"}>
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <MDTypography variant="h5" fontWeight="medium">
                Green School List
              </MDTypography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="flex-end" gap={1}>
              {/* {(meData?.role_id === 1 || meData?.role_id === 2) && (
                <MDButton
                  onClick={() => navigate("/green-school/phase-manage")}
                  sx={{
                    color: "white !important",
                    backgroundColor: "#1976d2",
                    "&:hover": { backgroundColor: "#155fa0" },
                    minWidth: "150px",
                  }}
                >
                  Manage Phase
                </MDButton>
              )} */}
              {meData?.role_id === 3 && (
                <MDButton
                  color={"dark"}
                  onClick={() => navigate("/green-school/add")}
                  sx={{
                    color: "white !important",
                    backgroundColor: "#1976d2",
                    "&:hover": { backgroundColor: "#155fa0" },
                    minWidth: "120px",
                  }}
                >
                  + Add New
                </MDButton>
              )}
            </Grid>
          </Grid>
          {/* </MDBox> */}
        </MDBox>
        <MDBox px={2} pt={0.5}>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                name="txtGroup"
                value={filters.txtGroup}
                onChange={(e) => setFilters({ ...filters, txtGroup: e })}
                placeholder="Enter Phase"
                displayName="Phase"
              />
            </Grid>
            {meData?.role_id !== 3 && (
              <Grid item size={{ xs: 12, md: 4 }}>
                <MDAutocomplete
                  label="District"
                  name="intDistrict"
                  value={filters.intDistrict}
                  options={districts}
                  onChange={(newValue) => {
                    setFilters({ ...filters, intDistrict: newValue });
                  }}
                  isFilter={true}
                />
              </Grid>
            )}
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTextField
                name="txtSchoolName"
                value={filters.txtSchoolName}
                onChange={(e) => setFilters({ ...filters, txtSchoolName: e })}
                placeholder="Enter School Name"
                displayName="School Name"
                inputType="onlyString"
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={2} justifyContent="center">
            {/* Search Button */}
            <Grid item xs={12} md={2} textAlign="center">
              <MDButton
                onClick={() => fetchUsers(0, pagination.pageSize, filters, sorting)}
                sx={{
                  color: "white !important",
                  backgroundColor: "#1976d2",
                  "&:hover": {
                    backgroundColor: "#155fa0",
                  },
                  minWidth: "120px",
                }}
              >
                Search
              </MDButton>
            </Grid>

            {/* Cancel Button */}
            <Grid item xs={12} md={2} textAlign="center">
              <MDButton
                variant="outlined"
                onClick={() => {
                  const cleared = {
                    txtGroup: "",
                    intDistrict: meData?.role_id === 3 ? meData.district : "",
                    txtSchoolName: "",
                    intPhase: "",
                  };
                  setFilters(cleared);
                  fetchUsers(0, pagination.pageSize, cleared);
                }}
                sx={{
                  color: "#b71c1c !important",
                  borderColor: "#b71c1c",
                  "&:hover": {
                    backgroundColor: "#fbe9e7",
                    borderColor: "#b71c1c",
                  },
                  minWidth: "120px",
                }}
              >
                Cancel
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
      <Box>
        <Grid container spacing={5}>
          <Grid item size={{ xs: 12, md: 12 }} className="listTable">
            {/* <Card sx={{ padding: 3, boxShadow: 3 }}> */}
            {/* {loading ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            ) : ( */}
            <Box sx={{ width: "100%", overflowX: "auto" }}>
              <Paper
                elevation={2}
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  backgroundColor: "#fff",
                  boxShadow: "none",
                  p: 2,
                }}
              >
                <MaterialReactTable
                  columns={filteredColumns}
                  data={data}
                  // getRowId={(row) => row.user_id}
                  enableGlobalFilter={false}
                  enableFullScreenToggle={false}
                  enableColumnFilters={false}
                  enableDensityToggle={true}
                  enableGrouping={false}
                  initialState={{
                    showColumnFilters: false,
                  }}
                  layoutMode="grid"
                  // enableRowNumbers
                  enableStickyHeader
                  manualFiltering
                  manualPagination
                  manualSorting
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // onColumnFiltersChange={setColumnFilters}
                  onColumnFiltersChange={(filters) => {
                    setColumnFilters(filters);
                    fetchUsers(
                      pagination.pageIndex,
                      pagination.pageSize,
                      filters,
                      sorting,
                      filters
                    );
                  }}
                  // enableFilters
                  // enableColumnFilterModes
                  // muiLinearProgressProps={{
                  //   color: "inherit",
                  //   sx: { height: "4px" },
                  // }}
                  state={{
                    // rowSelection: selectedRowIds,

                    columnFilters,
                    // globalFilter,
                    isLoading: loading,
                    pagination,
                    // showAlertBanner: isError,
                    // showProgressBars: isRefetching,
                    sorting,
                  }}
                  // muiTableContainerProps={{
                  //   sx: {
                  //     maxHeight: "70vh",
                  //     overflowY: "auto",
                  //   },
                  // }}
                  muiTableHeadProps={{
                    sx: {
                      padding: "0px", // won't apply directly to <thead>, but useful for general structure
                      backgroundColor: "#011F3A", // background on <thead> element itself
                    },
                  }}
                  enableColumnActions={false}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: "#004030",
                      color: "#fff",
                      // fontSize: '16px',
                      fontWeight: "bold",
                      position: "sticky", // Make header sticky
                      top: 0, // Stick it at the top
                      zIndex: 1, // Ensure it stays
                      "& .MuiTableSortLabel-root": {
                        "& .MuiTableSortLabel-icon": {
                          color: "#fff !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "#fff !important",
                        fontSize: "12px",
                        "::placeholder": {
                          color: "#e0e0e0", // Default (blurred) placeholder color
                          opacity: 1,
                        },
                      },
                      "& .MuiInputBase-root.Mui-focused .MuiInputBase-input::placeholder": {
                        color: "#ffffff", // Focused placeholder color
                      },
                      "& .MuiIconButton-root": {
                        color: "#fff",
                      },
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#e0e0e0",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#fff",
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#fff",
                      },

                      "& .MuiCheckbox-root": {
                        color: "#fff",
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      padding: "20x", // reduce from default 16px
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      "& td:nth-of-type(odd)": {
                        backgroundColor: "#000",
                      },
                      "& .MuiTableCell-body": {
                        padding: "25px",
                      },
                    },
                  }}
                  muiTableBodyRowProps={({ row }) => ({
                    sx: {
                      backgroundColor: row.index % 2 === 0 ? "#fff" : "#0846361c", // alternate row colors
                      "&:hover": {
                        backgroundColor: "#e0f7fa", // hover effect
                      },
                      "& .MuiTableCell-body": {
                        padding: "25px",
                      },
                    },
                  })}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                        marginLeft: "auto",
                      }}
                    >
                      <Tooltip title={"Export data to excel sheet"} arrow>
                        <Button
                          onClick={handleExportData}
                          sx={{
                            background:
                              "linear-gradient(90deg, rgba(2, 183, 255, 0.65) 30%,rgb(110, 199, 235) 100%)",
                            color: "#f4f4f4",
                            borderRadius: "8px",
                            padding: "10px 20px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s, transform 0.3s",
                            "&:hover": {
                              background:
                                "linear-gradient(90deg, rgba(55, 198, 254, 0.97) 30%,rgb(39, 169, 220) 100%))",
                              transform: "scale(1.05)",
                            },
                            "&:active": {
                              transform: "scale(0.95)",
                            },
                          }}
                          startIcon={<IconTableExport />}
                        >
                          {"Export To Excel"}
                        </Button>
                      </Tooltip>
                    </Box>
                  )}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: "#fff",
                      boxShadow: "none",
                    },
                  }}
                />
              </Paper>
            </Box>
            {/* )} */}
            {/* </Card> */}
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        open={Boolean(message.status)}
        autoHideDuration={3000}
        onClose={() => setMessage({ status: "", title: "", msg: "" })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setMessage({ status: "", title: "", msg: "" })}
          severity={message.status}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message.msg}
        </Alert>
      </Snackbar>
      <Footer />
    </DashboardLayout>
  );
};;

export default GreenSchoolList;
